import React from 'react';
import { useNavigate } from 'react-router-dom';
import SgsstTabs from '../components/SgsstTabs';
import { S } from '../components/sgsstUi';

const CARDS = [
  ['autoevaluacion', '📋', 'Autoevaluación de estándares mínimos', 'Res. 0312/2019 — 60 estándares, puntaje y clasificación.'],
  ['plan', '🗓️', 'Plan anual de trabajo', 'Cronograma de actividades del SG-SST por ciclo PHVA.'],
  ['matriz-legal', '⚖️', 'Matriz legal', 'Requisitos legales aplicables y su cumplimiento.'],
  ['permisos', '📝', 'Permisos de trabajo', 'Alturas, espacios confinados, trabajo en caliente…'],
  ['brigadas', '🚨', 'Brigadas y emergencias', 'Brigadistas y registro de simulacros.'],
  ['presupuesto', '💰', 'Presupuesto SG-SST', 'Rubros presupuestados y ejecución.'],
];

export default function SgsstCumplimiento() {
  const nav = useNavigate();
  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={S.head}><div><h1 style={S.h1}>Cumplimiento documental</h1><p style={S.sub}>Documentos y registros para la auditoría de la ARL.</p></div></div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))', gap: 14 }}>
        {CARDS.map(([slug, icon, title, desc]) => (
          <button key={slug} onClick={() => nav(`/sgsst/cumplimiento/${slug}`)} style={card}>
            <div style={{ fontSize: 28 }}>{icon}</div>
            <div style={{ color: '#f1f5f9', fontSize: 15, fontWeight: 700, marginTop: 8 }}>{title}</div>
            <div style={{ color: '#64748b', fontSize: 12.5, marginTop: 4 }}>{desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
const card = { textAlign: 'left', background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, cursor: 'pointer', display: 'flex', flexDirection: 'column' };
